import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { formatINR } from '@/lib/format';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export default function FinancialSummary() {
  const [pl, setPL] = useState([]);
  useEffect(() => { api.get('/reports/property-pl').then(r => setPL(r.data)); }, []);
  const totalIncome = pl.reduce((s, x) => s + x.income, 0);
  const totalExpense = pl.reduce((s, x) => s + x.expense, 0);
  return (
    <div>
      <PageHeader title="Financial summary" subtitle="Income, expense and net by property" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        <Card className="p-4"><div className="text-xs text-muted-foreground">Total income</div><div className="text-2xl font-display font-semibold tabular-nums">{formatINR(totalIncome)}</div></Card>
        <Card className="p-4"><div className="text-xs text-muted-foreground">Total expense</div><div className="text-2xl font-display font-semibold tabular-nums">{formatINR(totalExpense)}</div></Card>
        <Card className="p-4"><div className="text-xs text-muted-foreground">Net</div><div className="text-2xl font-display font-semibold tabular-nums">{formatINR(totalIncome - totalExpense)}</div></Card>
      </div>
      <Card className="p-4">
        <div className="text-sm font-semibold mb-2">Property P&amp;L</div>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={pl}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="property_name" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}k`} />
              <Tooltip formatter={(v) => formatINR(v)} />
              <Legend />
              <Bar dataKey="income" fill="hsl(152 60% 34%)" radius={[6, 6, 0, 0]} name="Income" />
              <Bar dataKey="expense" fill="hsl(0 84% 56%)" radius={[6, 6, 0, 0]} name="Expense" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
